module.exports = __webpack_public_path__ + "static/media/bg.c829adc8.png";